import type { Loadings, UserInfoType } from '../types';
import { authStateStore, AuthStateStore } from './authState';
class AuthSync {
  state: AuthStateStore;

  constructor(storeState: AuthStateStore) {
    this.state = storeState;
  }
  //Гетеры
  //______________________________________________________________________________________________
  public getLoadings() {
    return this.state.loadings;
  }

  //______________________________________________________________________________________________



  //Сетеры
  //______________________________________________________________________________________________
  public setLoadings(value: boolean, key: keyof Loadings) {
    this.state.loadings = { ...this.state.loadings, [key]: value };
  }


  public setUserInfo(userData: UserInfoType) {
    this.state.userInfo = { ...userData };
  }
 

  //______________________________________________________________________________________________
}

export const authSyncStore = new AuthSync(authStateStore);
export type AuthSyncStore = typeof authSyncStore;
